import _isNil from 'lodash/isNil';
import { getBookableStatusDisplay } from 'components/ClassesList/ClassesList.helpers';

// Manual services resolve "priced" and "disabled" from a different payload than
// integrated classes; everything after that normalisation is shared so the two
// lists always agree on the same underlying state.
export function getManualBookableStatusDisplay({ disabled, retailRateRequest, price, status, classPricingRule } = {}) {
  const pricingStatus = status ?? classPricingRule?.status;

  return getBookableStatusDisplay({
    disabled: disabled || pricingStatus === 'disabled',
    retailRateRequest,
    hasPrice: !_isNil(price),
  });
}
